import { render, staticRenderFns } from "./InvoiceReturnTracking.vue?vue&type=template&id=dc670672&scoped=true&"
import script from "./InvoiceReturnTracking.vue?vue&type=script&lang=js&"
export * from "./InvoiceReturnTracking.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReturnTracking.vue?vue&type=style&index=0&id=dc670672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc670672",
  null
  
)

export default component.exports